import { shouldUseFirebaseEmulators } from './firebaseEmulators';

/** Vite env keys required for Firebase client init (baked at build time). */
export const REQUIRED_FIREBASE_ENV_KEYS = [
  'VITE_FIREBASE_API_KEY',
  'VITE_FIREBASE_PROJECT_ID',
  'VITE_FIREBASE_APP_ID',
] as const;

export function getMissingFirebaseEnvKeys(): string[] {
  if (shouldUseFirebaseEmulators()) return [];
  // Static references prevent Vite from serializing unrelated legacy VITE_* values.
  const firebaseEnv = {
    VITE_FIREBASE_API_KEY: import.meta.env.VITE_FIREBASE_API_KEY,
    VITE_FIREBASE_PROJECT_ID: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    VITE_FIREBASE_APP_ID: import.meta.env.VITE_FIREBASE_APP_ID,
  };
  return REQUIRED_FIREBASE_ENV_KEYS.filter((key) => !String(firebaseEnv[key] ?? '').trim());
}

export function isFirebaseConfigured(): boolean {
  return getMissingFirebaseEnvKeys().length === 0;
}

export function renderFirebaseConfigErrorHtml(missingKeys: string[]): string {
  const isProd = import.meta.env.PROD;
  return `
    <main style="font-family: system-ui, sans-serif; max-width: 42rem; margin: 2rem auto; padding: 0 1rem; line-height: 1.5; color: #e8eaed; background: #101419; min-height: 100dvh;">
      <h1 style="font-size: 1.25rem; margin-bottom: 0.75rem;">PlayQuick web app is not configured</h1>
      <p>Missing build-time environment: ${missingKeys.map((k) => `<strong>${k}</strong>`).join(', ')}.</p>
      ${
        isProd
          ? `<p>Production Hosting was built without Firebase config at <strong>build time</strong>. Firebase <code>deploy</code> does not inject these — Vite bakes <code>VITE_*</code> into the JS bundle when you run <code>pnpm build:web</code>.</p>
             <p>Fix: fill <code>apps/web/.env</code> and run <code>pnpm run deploy:firebase</code> locally, <em>or</em> add GitHub Actions repository secrets (see <code>apps/web/.env.example</code>) so CI can build on push to <code>main</code>.</p>`
          : `<p>Copy values from <strong>Firebase Console → Project settings → Your apps → Web app</strong> into <code>apps/web/.env</code>, then restart <code>pnpm --filter @playquick/web dev</code>.</p>`
      }
    </main>`;
}
